




import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class Icon extends Vue {
  @Prop() public type!: string;
  public get iconCls() {
    return this.type || 'arrow';
  }
  @Emit('click')
  private iconClick() {}
}
